import React, { useState, useEffect, useContext } from "react";
import { httpService } from "../httpService";
import logo from "./logo.png";
import { Stack, Typography, CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { AlertContext } from "../contexts/AlertContext";

export default function AttendancePage() {
  const [attendee, setAttendee] = useState(null);
  const [loading, setLoading] = useState(false);
  const [marking, setMarking] = useState(false);
  const { id } = useParams();
  const { setAlertData } = useContext(AlertContext);
  const getData = async () => {
    setLoading(true);
    const { data } = await httpService.get(`viewofficial/${id}`);

    if (data) {
      setAttendee(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const markAttendance = () => {
    Swal.fire({
      icon: "question",
      title: "Enter password",
      input: "password",
    }).then(async (password) => {
      if (password.value !== "jamb123") {
        return Swal.fire({
          icon: "error",
          title: "Password Incorrect",
          text: "Password provided is wrong",
        });
      } else {
        setMarking(true);
        const { data, error } = await httpService.post("markattendance", {
          attendee: attendee._id,
        });

        if (data) {
          setAlertData({ open: true, message: data, severity: "success" });
        }
        if (error) {
          setAlertData({ open: true, message: error, severity: "error" });
        }
        setMarking(false);
      }
    });
  };
  return (
    <div>
      <div className="mt-5 mb-5 container">
        {loading && <CircularProgress />}
        {attendee && (
          <div>
            <div className="text-center">
              <Stack>
                <div>
                  <img src={logo} width="120" height="100" alt="logo" />
                </div>
                <div>
                  <div className="mt-2">
                    <Typography variant="h6" fontWeight={700}>
                      JOINT ADMISSIONS & MATRICULATION BOARD
                    </Typography>
                    <Typography textTransform={"uppercase"} fontWeight={500}>
                      Attendance Marker
                    </Typography>
                  </div>
                </div>
              </Stack>
            </div>
            <div className="mt-2">
              <img
                className="img-thumbnail"
                loading="eager"
                src={attendee.imageURL}
                alt=""
              />
              <div className="col-lg-4 mt-2">
                <Typography gutterBottom>
                  {attendee.title} {attendee.firstName} {attendee.lastName}
                </Typography>
                <Typography gutterBottom>
                  {attendee.role} {attendee.code}
                </Typography>
                <Typography gutterBottom>{attendee.institution}</Typography>

                <div className="mt-2">
                  <LoadingButton
                    color="success"
                    variant="contained"
                    onClick={markAttendance}
                    loading={marking}
                    endIcon={<FontAwesomeIcon icon={faCheckSquare} />}
                  >
                    Mark Attendance
                  </LoadingButton>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
